import { render } from "./kalio-button.vue?vue&type=template&id=26ab8be6"
import script from "./kalio-button.vue?vue&type=script&lang=js"
export * from "./kalio-button.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__